import { InputSize } from './Input/types';

const getHeightClass = (size: InputSize): string => {
    switch (size) {
        case 'small':
            return 'h-8';
        case 'medium':
            return 'h-10';
        case 'large':
            return 'h-12';
        default:
            return 'h-10';
    }
};

const LoadingInput: React.FC<{
    size?: InputSize;
    helperText?: boolean;
    helperTextMarginTop?: boolean;
    heightClass?: string;
}> = ({ size = 'medium', helperText = false, helperTextMarginTop = false, heightClass }) => {
    return (
        // Decorative height placeholder — kept out of the a11y tree so it is not announced
        // as an unlabelled box (same as Skeleton).
        <div className="w-full" aria-busy="true" aria-hidden="true">
            <div
                className={`w-full ${heightClass ?? getHeightClass(size)} rounded-xl border border-solid border-[var(--malachite-card-border)] bg-[var(--malachite-card-border)] flex items-center justify-center shadow-[var(--malachite-shadow-default)]`}
            />
            {helperText && (
                <div className={`${helperTextMarginTop ? 'mt-1 ' : ''}pl-2 text-[13px]`}>
                    <span className="inline-block h-2.5 w-40 rounded-md bg-[var(--malachite-card-border)] align-middle" />
                </div>
            )}
        </div>
    );
};

export default LoadingInput;
